export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2g-acf778cd6a51b4d74e25d54c887bde1c.webp";